import { useEffect, useMemo, useState } from 'react';
import { Source, Layer, Popup, useMap } from 'react-map-gl/mapbox';

const EmergencyCircuitsPerLayer = ({ geojson, visibleIds }) => {
  const [popupInfo, setPopupInfo] = useState(null);
  const { current: map } = useMap();

  const visibleFeatures = useMemo(
    () => geojson?.features?.filter(f => visibleIds.has(f.properties.id)) ?? [],
    [geojson, visibleIds]
  );
  const allLayerIds = geojson?.features?.map(f => `emergency-circuit-${f.properties.id}`) ?? [];

  useEffect(() => {
    if (!map || !geojson) return;

    const handleClick = e => {
      const features = map.queryRenderedFeatures(e.point, { layers: allLayerIds.filter(id =>
        visibleFeatures.some(f => `emergency-circuit-${f.properties.id}` === id)
      )});
      if (features.length > 0) {
        setPopupInfo(null);
        setTimeout(() => {
          setPopupInfo({
            longitude: e.lngLat.lng,
            latitude: e.lngLat.lat,
            nombre: features[0].properties.nombre
          });
        }, 0);
      } else {
        setPopupInfo(null);
      }
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, geojson, visibleFeatures]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!map || !geojson) return;

    const visibleLayerIds = visibleFeatures.map(f => `emergency-circuit-${f.properties.id}`);
    visibleLayerIds.forEach(id => {
      map.on('mouseenter', id, () => { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', id, () => { map.getCanvas().style.cursor = ''; });
    });

    return () => {
      visibleLayerIds.forEach(id => {
        map.off('mouseenter', id);
        map.off('mouseleave', id);
      });
    };
  }, [map, geojson, visibleFeatures]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!geojson) return null;

  return (
    <>
      {visibleFeatures.map(feature => (
        <Source
          key={feature.properties.id}
          id={`emergency-circuit-${feature.properties.id}`}
          type="geojson"
          data={{ type: 'FeatureCollection', features: [feature] }}
        >
          <Layer
            id={`emergency-circuit-${feature.properties.id}`}
            type="line"
            paint={{
              'line-color': feature.properties.color || '#888888',
              'line-width': 4
            }}
          />
        </Source>
      ))}

      {popupInfo && (
        <Popup
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          anchor="bottom"
          onClose={() => setPopupInfo(null)}
        >
          <div style={{ lineHeight: '1.4em' }}>
            <div>{popupInfo.nombre}</div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default EmergencyCircuitsPerLayer;
